export default __webpack_public_path__ + "static/media/calendar_dark.51fb1d2d.svg";